import React, { useEffect, useState } from "react";
import "./App.css";
import ErrorBoundary from "components/ErrorBoundary";
import { networkErrorHandler } from "@utils/networkErrorHandler";

// A component to show when there's a network error
const NetworkErrorFallback = ({
  error,
  onRetry,
}: {
  error: Error | null;
  onRetry: () => void;
}) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
    <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">
      <div className="text-6xl mb-4">🔌</div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        Connection Error
      </h1>
      <p className="text-gray-600 mb-6">
        We're having trouble connecting to our servers. This might be due to
        network issues or server maintenance.
      </p>
      {error && (
        <p className="text-sm text-gray-500 mb-6">
          Error: {error.message || "Network request failed"}
        </p>
      )}
      <button
        onClick={onRetry}
        className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary-dark transition-colors"
      >
        Retry Connection
      </button>
      <div className="mt-6 text-sm text-gray-500">
        <p>
          If the problem persists, please try again later or contact support.
        </p>
      </div>
    </div>
  </div>
);

const AppContent = () => {
  const [networkError, setNetworkError] = useState<Error | null>(null);

  useEffect(() => {
    if (
      !document.querySelector('script[src*="accounts.google.com/gsi/client"]')
    ) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        (window as any).googleScriptLoaded = true;
      };
      script.onerror = () => {
        console.error("App: Failed to load Google OAuth script");
      };
      document.head.appendChild(script);
    } else {
    }

    // Initialize network error handler
    networkErrorHandler.initialize({
      onNetworkError: (error: Error) => {
        console.error("Network error detected:", error);
        setNetworkError(error);
      },
      onOnline: () => {
        setNetworkError(null);
      },
      onOffline: () => {
        setNetworkError(
          new Error(
            "You are currently offline. Please check your internet connection.",
          ),
        );
      },
    });

    // Check if we're offline when the app loads
    if (!navigator.onLine) {
      setNetworkError(
        new Error(
          "You are currently offline. Please check your internet connection.",
        ),
      );
    }

    // Cleanup
    return () => {
      networkErrorHandler.cleanup();
    };
  }, []);

  const handleRetry = () => {
    setNetworkError(null);
    window.location.reload();
  };

  // If there's a network error, show the error UI
  if (networkError) {
    return <NetworkErrorFallback error={networkError} onRetry={handleRetry} />;
  }

  // Normal app content
  return (
    <div
      style={{
        width: "100vw",
      }}
    >
      {/* <SearchCard
				location='New York, USA'
				price='$500-$2,500'
				propertyType='Private House'
				propertySize='120m-150m'
			/> */}
      {/* <PropertyCard title="Palm Harbor" poster={propertyImage} type="sale" /> */}
    </div>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <AppContent />
    </ErrorBoundary>
  );
};

export default App;
